<template>
  <div class="collapse-img">
    <!-- header（cell 风格） -->
    <div
      class="collapse-header"
      :class="{ 'is-active': isOpen, 'bottom-line': !isOpen }"
      @click="toggle"
    >
      <span class="title">{{ title }}</span>

      <span class="icon">
        <i class="icon-outlined_pull-down"></i>
      </span>
    </div>

    <!-- content -->
    <transition name="collapse" @after-enter="onCollapseAfterEnter">
      <div v-show="isOpen" class="collapse-content">
        <!-- 空状态 -->
        <div v-if="!value.length" class="empty">
          <span class="empty-text">No image</span>
        </div>

        <rich-scroll v-else ref="richScroll" direction="horizontal">
          <!-- 图片列表 -->
          <div class="img-list">
            <div v-for="(item, index) in value" :key="index" class="img-item">
              <img :src="item" @click="showImage(index)" />
            </div>
          </div>
        </rich-scroll>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'CollapseImg',
  props: {
    title: {
      type: String,
      default: 'Store logo',
    },
    value: {
      type: Array,
      default: () => [],
    },
    defaultOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: this.defaultOpen,
      touchStartX: 0,
      touchStartY: 0,
      tapMoveThreshold: 8,
      richScrollRefreshTimer: null,
    }
  },
  watch: {
    isOpen(val) {
      if (val && this.value.length) {
        this.scheduleRichScrollRefresh()
      }
    },
    value: {
      deep: true,
      handler() {
        if (this.isOpen && this.value.length) {
          this.scheduleRichScrollRefresh()
        }
      },
    },
  },
  mounted() {
    if (this.isOpen && this.value.length) {
      this.scheduleRichScrollRefresh()
    }
  },
  beforeDestroy() {
    if (this.richScrollRefreshTimer != null) {
      clearTimeout(this.richScrollRefreshTimer)
      this.richScrollRefreshTimer = null
    }
  },
  methods: {
    /** better-scroll 需在布局稳定后 refresh，与 StoreFilter 里 filterScroll 用法一致 */
    scheduleRichScrollRefresh() {
      this.$nextTick(() => {
        if (this.richScrollRefreshTimer != null) {
          clearTimeout(this.richScrollRefreshTimer)
        }
        this.richScrollRefreshTimer = setTimeout(() => {
          this.richScrollRefreshTimer = null
          this.refreshRichScroll()
        }, 0)
      })
    },
    refreshRichScroll() {
      const rs = this.$refs.richScroll
      if (rs && rs.scroll && typeof rs.scroll.refresh === 'function') {
        rs.scroll.refresh()
      }
    },
    onCollapseAfterEnter() {
      if (this.isOpen && this.value.length) {
        this.scheduleRichScrollRefresh()
      }
    },
    toggle() {
      this.isOpen = !this.isOpen
    },
    showImage(index) {
      this.$createImagePreview({
        imgs: this.value,
        initialIndex: index,
      }).show()
    },
    handleTouchStart(event) {
      const touch = event.touches && event.touches[0]
      if (!touch) return
      this.touchStartX = touch.clientX
      this.touchStartY = touch.clientY
    },
    handleTouchEnd(event, index) {
      const touch = event.changedTouches && event.changedTouches[0]
      if (!touch) return
      const deltaX = Math.abs(touch.clientX - this.touchStartX)
      const deltaY = Math.abs(touch.clientY - this.touchStartY)
      if (deltaX <= this.tapMoveThreshold && deltaY <= this.tapMoveThreshold) {
        this.showImage(index)
      }
    },
  },
}
</script>

<style scoped>
/* 与门店筛选 StoreFilter 横向区一致：list-wrapper flex，避免单个子节点被压满视口无法横向溢出 */
::v-deep .rich-scroll-list-wrapper {
  display: flex;
}

.collapse-img {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

/* header（类似 cell） */
.collapse-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px 0;
  font-size: 32px;
  cursor: pointer;
}

.bottom-line {
  border-bottom: 1px solid #ebebeb;
}

.title {
  color: #595c66;
  font-size: 28px;
  font-family: 'DiDi Sans Pro';
}

/* icon */
.icon i {
  display: inline-block;
  transition: transform 0.3s;
}

/* 展开时旋转 */
.collapse-header.is-active .icon i {
  transform: rotate(180deg);
}

/* 图片列表横向；flex-shrink:0 避免作为 rich-scroll 唯一子节点被压成视口宽度 */
.img-list {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  flex-shrink: 0;
  gap: 10px;
}

.img-item {
  flex: 0 0 auto;
  width: clamp(200px, 70vw, 280px);
  height: 280px;
  border-radius: 8px;
  background: #f5f5f5;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.img-item img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 空状态 */
.empty {
  height: 200px;
  background: #f5f5f5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 动画 */
.collapse-enter-active,
.collapse-leave-active {
  transition: all 0.25s ease;
}

.collapse-enter,
.collapse-leave-to {
  opacity: 0;
  transform: scaleY(0.95);
}

.empty-text {
  color: #999;
  font-size: 24px;
}
</style>
